export const RECIPE_FILTER_GROUP_RECIPE_TYPE = "recipeType";
export const RECIPE_FILTER_GROUP_INGREDIENT = "ingredient";
export const RECIPE_FILTER_GROUP_SOURCE = "source";
export const RECIPE_FILTER_GROUP_TASTE = "taste";
